import styled from 'styled-components'
import { TextInput } from 'ui'

export const Input = styled(TextInput)`
    margin-bottom: 10px;
`
